import { render, staticRenderFns } from "./FormRadioGroupTiles.vue?vue&type=template&id=590afc22&scoped=true&"
import script from "./FormRadioGroupTiles.vue?vue&type=script&lang=ts&"
export * from "./FormRadioGroupTiles.vue?vue&type=script&lang=ts&"
import style0 from "./FormRadioGroupTiles.vue?vue&type=style&index=0&id=590afc22&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590afc22",
  null
  
)

export default component.exports